export class CopyToClipboard {
    constructor(element) {
        this.copiedMessage = "Copied to clipboard";
        this.copyToClipboardElement = element instanceof HTMLElement ? element : (element[0] || element);
        this.copyToClipboardElement.addEventListener("click", (event) => this.onClick(event));
    }
    onClick(event) {
        event.preventDefault();
        const href = this.copyToClipboardElement.href || this.copyToClipboardElement.getAttribute("href") || "";
        navigator.clipboard.writeText(href);
        const tooltip = this.copyToClipboardElement.querySelector(".tooltip");
        if (!tooltip)
            return false;
        if (tooltip.classList.contains("show") || tooltip.classList.contains("hide")) {
            return false;
        }
        tooltip.classList.remove("hidden");
        tooltip.textContent = this.copiedMessage;
        setTimeout(() => {
            tooltip.classList.remove("opacity-0");
            tooltip.classList.add("show");
            tooltip.style.transform = "translateY(calc(-100% - 4px))";
            setTimeout(() => {
                tooltip.classList.add("hide");
                tooltip.style.transform = "translateY(calc(-100% - 12px))";
                tooltip.classList.add("opacity-0");
                setTimeout(() => {
                    tooltip.classList.add("hidden");
                    tooltip.style.transform = "";
                    tooltip.classList.remove("show");
                    tooltip.classList.remove("hide");
                    tooltip.textContent = "";
                }, 600);
            }, 2000);
        }, 1);
        return false;
    }
}
